import $ from "jquery";
import authService from "./authService";
import moment from "moment";

export const NavigationPage = (status, user_status) => {
  const { db_name, payment_token } = authService.getUserDetail();
  if (status === "P") {
    if (user_status === "UP") {
      return (window.location.href = `https://${
        process.env.REACT_APP_PORTAL_DOMAIN
      }/${"choose-plan"}`);
    } else if (user_status === "UF") {
      return (window.location.href = `https://${
        process.env.REACT_APP_PORTAL_DOMAIN
      }/${"order-summary"}`);
    } else if (user_status === "RE") {
      if (db_name === "") {
        return (window.location.href = `https://${process.env.REACT_APP_PORTAL_DOMAIN}/fetch-payment/${payment_token}`);
      } else {
        return (window.location.href = `https://${
          process.env.REACT_APP_PORTAL_DOMAIN
        }/${"rica-process"}`);
      }
    } else {
      return (window.location.href = `https://${
        process.env.REACT_APP_PORTAL_DOMAIN
      }/${"choose-number"}`);
    }
  } else {
    return (window.location.href = `https://${
      process.env.REACT_APP_PORTAL_DOMAIN
    }/${"dashboard"}`);
  }
};

export const randomString = (length) => {
  var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

export const removeBackdrop = () => {
  $("body").removeClass("modal-open");
  $(".modal-backdrop").remove();
};

export const getFormattedDate = (date) => {
  let formattedDate;
  const FORMAT = "DD-MMM-YYYY";
  if (date) {
    const moment_date = moment.utc(date);
    if (moment_date.isValid()) {
      formattedDate = moment_date.format(FORMAT);
    }
  }

  if (!formattedDate) {
    formattedDate = moment().format(FORMAT);
  }
  return formattedDate;
};

export const convertTo24HourFormatWithSeconds = (time) => {
  const [hours, minutes] = time.match(/\d+/g).map(Number);
  const isPM = time.includes("PM");
  const convertedHours =
    isPM && hours !== 12 ? hours + 12 : !isPM && hours === 12 ? 0 : hours;

  return `${String(convertedHours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:00`;
};

export const REACT_APP_GOOGLE_APP_ID =
  "753511039530-lnooti2rk692iobli6d8uu1lj5lvbq4o.apps.googleusercontent.com";
export const REACT_APP_LINKEDIN_APP_ID = "78cqir2karm6a5";
export const REACT_APP_LINKEDIN_APP_SECRET = "DV8zq0QFnb6oGg21";
